<h2 mat-dialog-title>
  <svg class="icon-24"><use href="assets/images/ok-icons-sprite.svg#users-s"></use></svg>
  Tilføj adgangsgrupper til alle ladepunkter
</h2>
<button class="btn-close btn-icon" mat-dialog-close title="Luk dialog">
  <mat-icon class="material-icons" (click)="dialogRef.close()">close</mat-icon>
</button>

<mat-dialog-content>
  <form [formGroup]="form">
    <ok-feedback-info>
      <div>
        <strong
          >{{ data.numberOfChargingStationLocations }} ladepunkter på '{{ data.chargingStationLocationName }}' bliver opdateret.</strong
        >
        <br />
        Eksisterende adgangsgrupper på ladepunkterne bevares.
      </div>
    </ok-feedback-info>

    <div class="form-row">
      <mat-form-field>
        <mat-label>Adgangsgrupper</mat-label>
        <mat-select formControlName="accessGroupIdentifiers" multiple okCustomDropDownArrowDirective>
          @for (accessGroup of accessGroups$ | async; track accessGroup.identifier) {
            <mat-option [value]="accessGroup.identifier">
              {{ accessGroup.name }}
            </mat-option>
          }
        </mat-select>
        <mat-icon matSuffix></mat-icon>
      </mat-form-field>
    </div>
  </form>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button (click)="dialogRef.close()">Annuller</button>
  <button mat-flat-button color="primary" (click)="updateAccessGroups()">Tilføj</button>
</mat-dialog-actions>
